export interface LastGeneratedReport {
  date: string;
  url: string;
}

export interface ReportAsyncTypeRow {
  id: string;
  name: string;
  description: string;
  instructions: string;
  dynamicFormId: number | null;
  generating: boolean;
  lastGenerated: LastGeneratedReport | null;
}

export interface ReportAsyncForm {
  structure: any[];
  options?: Record<string, any>;
}

export enum ReportAsyncGroup {
  Default = 'default',
  Coursables = 'coursables',
  SIES = 'sies',
}
